import { render } from "./CovidInfo.vue?vue&type=template&id=b3237944&scoped=true"
import script from "./CovidInfo.vue?vue&type=script&lang=js"
export * from "./CovidInfo.vue?vue&type=script&lang=js"

import "./CovidInfo.vue?vue&type=style&index=0&id=b3237944&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3237944"

export default script